export const TEST_ID = {
  loginPage: 'loginPage',
};
